export default class CartaoValidationService {
    constructor() {
    }
   
    IsNumeroAntigo(cartao) {
        if (cartao.codigoCartao == undefined || cartao.codigoCartao == '') {
            return true;
        } else {
            return false;
        }
    };

    ValidarNumeroAntigo(cartao) {
        if(!this.ConferirVazioOuNulo(cartao.cpf)){
            if(!this.ConferirVazioOuNulo(cartao.numeroChip)) {
                 return true;
            } 
        } 
        return false;
    };

    ValidarNumeroNovo(cartao) {
        if(!this.ConferirVazioOuNulo(cartao.cpf)){
            if(!this.ConferirVazioOuNulo(cartao.digitoCartao)) {
                 if (!this.ConferirVazioOuNulo(cartao.codigoCartao)) {
                    return true;
                 }
            } 
         } 
         return false;
    };

    TipoCartao(cartao) {
        if (this.IsNumeroAntigo(cartao)) {
            return "NumeroAntigo"
        } else {
            return "ComDigito"
        }
    };

    ConferirVazioOuNulo(val) {
        if (val == null || val == undefined || val == "") {
            return true
        } 
        return false
    };
}